module.exports = __webpack_public_path__ + "img/candies.1df3bb36.gif";